import React from 'react';
import { Row, Alert } from 'antd';
import { FormField, maxLength } from 'common';
import { SearchTypeFormNames } from './TaxMaps.constants';
import styles from './TaxMaps.module.scss';
import { GetDriversResult } from './models';

const warnText = [maxLength(20)];

interface Props {
  driversData: GetDriversResult;
}

const TaxMapsFormTabs: React.FC<Props> = ({ driversData }) => {
  return (
    <>
      <Row type="flex" align="middle">
        {driversData && driversData.drivers && driversData.drivers.length ? (
          driversData.drivers.map(({ index, fIndex, name }) => {
            if (name !== 'Swis')
              return (
                <FormField
                  warn={warnText}
                  label={name}
                  name={`${SearchTypeFormNames.DRIVERS_SEARCH}.${fIndex}`}
                  className={styles.input}
                  key={index}
                  disabled={name === 'Swis'}
                />
              );
            else return null;
          })
        ) : (
          <Alert
            className={`w-100`}
            message="Please select County or Town or Village to proceed with search."
            type="warning"
          />
        )}
      </Row>
    </>
  );
};

export default TaxMapsFormTabs;
